import React from 'react';

import {
  Actions as UIActions,
  Action,
  RefreshIcon,
  FileDownloadIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  ACTION_ARCHIVE,
  ACTION_DELETE,
  ACTION_EXPORT,
  ACTION_DUPLICATE,
  ACTION_EDIT,
  ACTION_RESTORE,
  ACTION_UPDATE,
  PERMISSION_EXPORT,
  ACTION_SYNC_PARTNER_AUDIENCES,
  ACTION_ADD_PARTNER_AUDIENCES,
} from 'scenes/CustomAudiences/Audiences/constants';

const Actions = ({
  limit,
  actions,
  onSync,
  onExport,
  onEdit,
  onDuplicate,
  onSyncPartnerAudiences,
  onAddPartnerAudiences,
  onArchive,
  onRestore,
  onDelete,
  withPartnerActions,
  withDuplicate,
}) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <UIActions limit={limit}>
          <Action
            label={'Update'}
            icon={<RefreshIcon />}
            disabled={!isActionAllowed(ACTION_UPDATE)}
            onClick={onSync}
          />
          <Action
            label={'Export'}
            icon={<FileDownloadIcon />}
            disabled={
              !isActionAllowed(ACTION_EXPORT) ||
              !isActionAllowed(PERMISSION_EXPORT)
            }
            onClick={onExport}
          />
          {withPartnerActions && (
            <Action label={'Partner Audiences'}>
              <Action
                label={'Sync Partner Audiences'}
                icon={<RefreshIcon />}
                disabled={!isActionAllowed(ACTION_SYNC_PARTNER_AUDIENCES)}
                onClick={onSyncPartnerAudiences}
              />
              {onAddPartnerAudiences && (
                <Action
                  label={'Add Partner Audiences'}
                  disabled={!isActionAllowed(ACTION_ADD_PARTNER_AUDIENCES)}
                  onClick={onAddPartnerAudiences}
                />
              )}
            </Action>
          )}
          {withDuplicate ? (
            <Action
              label={'Duplicate'}
              disabled={!isActionAllowed(ACTION_DUPLICATE)}
              onClick={onDuplicate}
            />
          ) : null}
          <Action
            label={'Edit'}
            disabled={!isActionAllowed(ACTION_EDIT)}
            onClick={onEdit}
          />
          {isActionAllowed(ACTION_ARCHIVE) ? (
            <Action label={'Archive'} onClick={onArchive} />
          ) : null}
          {isActionAllowed(ACTION_RESTORE) ? (
            <Action label={'Restore'} onClick={onRestore} />
          ) : null}
          <Action
            label={'Delete'}
            disabled={!isActionAllowed(ACTION_DELETE)}
            onClick={onDelete}
          />
        </UIActions>
      )}
    </Permissions>
  );
};

export default Actions;
